import { createContext, useContext, useState } from 'react';
import React from 'react';

const ToggleContext = createContext({
    on: false,
    toggle: () => {
        return;
    },
});

export const ToggleProvider = ({ children }: { children: React.ReactNode }) => {
    const [on, setOn] = useState(false);
    const toggle = () => {
        setOn((prevState) => !prevState);
    };
    const contextValue = {
        on,
        toggle,
    };

    return <ToggleContext.Provider value={contextValue}>{children}</ToggleContext.Provider>;
};

export const useToggle = () => useContext(ToggleContext);
